import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

const Placeholder = styled('div')(({ theme }) => ({
  '@keyframes shimmer': {
    '0%': {
      backgroundPosition: '-200px 0'
    },
    '100%': {
      backgroundPosition: 'calc(200px + 100%) 0'
    }
  },
  animation: 'shimmer 1.5s ease-in-out infinite',
  backgroundColor: theme.palette.focus10.main,
  backgroundImage: `linear-gradient(90deg, ${theme.palette.focus10.main}, ${theme.palette.focus.main}, ${theme.palette.focus10.main})`,
  backgroundSize: '200px 100%',
  backgroundRepeat: 'no-repeat',
  borderRadius: '4px',
  boxSizing: 'border-box'
}));

const content = '&nbsp;';
const newline = '<br />';
const Skeleton = ({
  lines = 1,
  width = '100%',
  height,
  ...rest
}) => {
  const placeholders = { __html: Array(lines).fill(content).join(newline) };

  return (
    <Placeholder
      sx={{ width, height }}
      {...rest}
      dangerouslySetInnerHTML={placeholders}
    />
  );
};

export default Skeleton;

Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  lines: PropTypes.number
};
